import axios from 'axios';
import config  from '@/config/config';

export default {
    async login(params) {
        return await axios.post(config.endpoint + "/api/login_admin", params).then(response => {
            return response.data;
        });
    },
}